import { useMemo } from 'react';
import { filterRouteParams } from '../utils/filterRouteParams';
import { history } from '../history';
import { getRouteByIdLang } from '../routes';
import { useLocation } from './useLocation';
function dummyNavigate() {
    /* empty */
}
dummyNavigate.href = undefined;
dummyNavigate.hrefLang = undefined;
dummyNavigate.onClick = (event) => {
    event.preventDefault();
};
dummyNavigate.isSameRoute = false;
dummyNavigate.isSameExactly = false;
export function useLink(routeId, params, 
/** @deprecated */
state, 
/** @deprecated */
action = 'push', filterParams = false) {
    const { route, pathname, search, hashParams, persistedRouteParams } = useLocation();
    const currentRouteId = route?.id;
    const currentParams = route?.params;
    const persitedTargetRouteParams = persistedRouteParams?.[routeId];
    return useMemo(() => {
        if (!routeId) {
            console.info(`[useLink] Link was generated without a route definition.`);
            return dummyNavigate;
        }
        const baseParams = filterParams ? { ...currentParams, ...hashParams } : {};
        const combinedParams = {
            ...baseParams,
            ...persitedTargetRouteParams,
            ...params,
        };
        const route = getRouteByIdLang(routeId, combinedParams?.lang);
        try {
            const filteredParams = filterParams
                ? filterRouteParams(routeId, combinedParams)
                : combinedParams;
            const href = route ? route.getHref(filteredParams) : '';
            // because of NPM history package BUG - need '?' in every request
            // when fix, edit routes.ts too
            // https://github.com/ReactTraining/history/issues/814
            const isSameExactly = `${pathname}${search ? search : '?'}` === href;
            const navigate = (act = action) => {
                history[isSameExactly ? 'replace' : act](href);
            };
            navigate.isSameRoute = currentRouteId === routeId;
            navigate.isSameExactly = isSameExactly;
            navigate.href = href;
            navigate.hrefLang = combinedParams?.lang;
            navigate.onClick = (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (e.ctrlKey || e.metaKey) {
                    window.open(href, '_blank');
                }
                else {
                    navigate();
                }
            };
            return navigate;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            console.error(`[useLink] Error while generating route "${routeId}" with params:`, params, message);
            return dummyNavigate;
        }
    }, [
        action,
        persitedTargetRouteParams,
        params,
        routeId,
        currentRouteId,
        currentParams,
        pathname,
        search,
        filterParams,
    ]);
}
//# sourceMappingURL=useLink.js.map